// extracted by mini-css-extract-plugin
module.exports = {"linkItem":"Qf9oVr6 item","article-list":"_3DjfthG ui brown segment","articleList":"_3DjfthG ui brown segment","header":"_2Gbp6v5"};